export default __webpack_public_path__ + "static/media/portfolio.872ae2ec.png";